import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
export function App() {
  useEffect(() => {
    // ============================================
    // VERIFICACIÓN DE UTMs EN CONSOLA
    // ============================================

    // Función para obtener parámetros de la URL
    function getParameterByName(name: string, url: string = window.location.href): string | null {
      name = name.replace(/[\[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    // Capturar UTMs de la URL
    const utmSource = getParameterByName('utm_source');
    const utmCampaign = getParameterByName('utm_campaign');
    const utmMedium = getParameterByName('utm_medium');
    const utmContent = getParameterByName('utm_content');
    const utmTerm = getParameterByName('utm_term');

    // MOSTRAR EN CONSOLA
    console.log('🔍 VERIFICACIÓN DE DATOS FACEBOOK');
    console.log('📌 URL actual:', window.location.href);
    console.log('📊 UTMs DETECTADOS:');
    console.log('   • utm_source:', utmSource || '❌ No detectado');
    console.log('   • utm_campaign:', utmCampaign || '❌ No detectado');
    console.log('   • utm_medium:', utmMedium || '❌ No detectado');
    console.log('   • utm_content:', utmContent || '❌ No detectado');
    console.log('   • utm_term:', utmTerm || '❌ No detectado');

    // Verificación específica para Facebook
    if (utmSource === 'facebook' || utmSource === 'fb' || utmSource?.includes('facebook')) {
      console.log('✅ DATOS DE FACEBOOK DETECTADOS CORRECTAMENTE');
      console.log('   • Campaña:', utmCampaign || 'No especificada');
      console.log('   • Contenido:', utmContent || 'No especificado');
    } else if (utmSource) {
      console.log('ℹ️ Datos detectados pero no son de Facebook (fuente:', utmSource, ')');
    } else {
      console.warn('⚠️ No se detectaron UTMs. Verifica:');
      console.warn('   1. Que el anuncio de Facebook tenga parámetros UTM');
      console.warn('   2. La URL del anuncio debe ser algo como:');
      console.warn('      https://elnegociodelte.raicesdivinas.com/?utm_source=facebook&utm_campaign=nombre_campana');
    }

    // ============================================
    // TU CÓDIGO EXISTENTE (Meta Pixel y UTMify)
    // ============================================
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n = ((window as any).fbq = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      }) as any;
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    //;(window as any).fbq('init', '814608394747562')
    //;(window as any).fbq('track', 'PageView')

    // Utmify UTM tracking script
    const utmScript = document.createElement('script');
    utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmScript.setAttribute('data-utmify-prevent-subids', '');
    utmScript.async = true;
    utmScript.defer = true;
    document.head.appendChild(utmScript);
    (window as any).pixelId = '69a5b0a02e0c1b4945b8a61d';
    const pixelScript = document.createElement('script');
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    document.head.appendChild(pixelScript);
  }, []); // El array vacío ejecuta solo una vez al cargar

  return <SalesPage data-id="element-0" />;
}